import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UsersService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'meu-modal-forgot-password',
  templateUrl: './modal-forgot-password.component.html',
  styleUrls: ['./modal-forgot-password.component.scss']
})
export class ModalForgotPasswordComponent implements OnInit {
  constructor(
	private dialogRef: MatDialogRef<ModalForgotPasswordComponent>,
	private usersService:UsersService,
	private toastr:ToastrService,
	@Inject(MAT_DIALOG_DATA) public data,
  ) { }
  isShowChange:boolean=false;
  emailName:"";
  forgotForm=new FormGroup({
	username: new FormControl('', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z]{2,4}$")]),
  })
  ngOnInit() {
	  if(this.data!=null){
		if(this.data.isShowChange){
			this.isShowChange=true;
			this.emailName=this.data.emailName;
	  }
	  }
  }
  closeModal(){
	this.dialogRef.close(true);
  }
  forgotPassword(){
	const controls = this.forgotForm.controls;
    if (this.forgotForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
	  );
	  return;
	}
	this.usersService.apiUsersForgotPasswordPost(this.forgotForm.value.username).subscribe(res=>{
	  if(res.success){
		this.dialogRef.close({event:true,emailName:this.forgotForm.value.username});
		  this.isShowChange=true;
		  this.emailName=this.forgotForm.value.username;
	  }else{
		  this.toastr.error(res.message);
	  }
	})
}
}
